<template>
  <div class="smsc-container">
     <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
            <div class="form-group has-search">
                        <span class="fa fa-search form-control-feedback"></span>
                    <input
                    @input="onQuickFilterChanged()"
                    id="quickFilter"
                    v-model="searchProduct"
                    class="filter_input_user form-control-user"
                    >
                </div>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">

        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="d-flex flex-wrap">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <per-page
            :currentPerPage="per_page"
            :pageStart="pageStart"
            :pageEnd="pageEnd"
            :total="total"
            @change-per-page="ChangePerPage($event)"
          />
        </div>
        <div class="d-flex flex-wrap">
          <active-only
            class="mt-3 ml-3"
            @toggle="SearchWithField($event, 'status')"
          />
        </div>
      </div>



      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>
  <modal-vue v-if="this.$store.getters['user/GetNewPassword']">
    <div class="modify-plan-container">
          <span class="close-icon" @click="Close">
            <i aria-hidden="true" class="v-icon notranslate view-icon p-lg-1 fas fa-times theme--light"></i>
          </span>
      <p class="title mb-8">Change New Password</p>
      <div class="mb-8">
        <div class="input-group">
          <input type="text"
                 v-model="new_password"
                 :class="{'input': true, 'is-danger': errors.has('new_password') }" name="new_password"
                 class="form-control" placeholder="New Password" >
          <span v-show="errors.has('new_password')" class="help is-danger">{{ errors.first('new_password') }}</span>
        </div>
      </div>
      <button type="button" class="btn button btn-success" @click="SaveNewPass">Save</button>
    </div>
  </modal-vue>




      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import {mapGetters} from 'vuex'
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import ModalVue from '../../../../views/pages/user-settings/Modal'
// Cell Renderer components
import CellRendererActions from './cell-renderer/CellRendererActions'
import CellRendererStatus from './cell-renderer/CellRendererStatus'

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,
    vSelect,
     ModalVue,
    //Cell Renderer components
    CellRendererActions,
    CellRendererStatus
  },
  computed:{
    ...mapGetters([
      'user/GetNewPassword'
    ])
  },
  data() {
    return {
      // table header value
      searchProduct: '',
      // modal_window: this.$store.getters['user/GetNewPassword'],
      new_password:"",

      columnDefs: [
        {
          headerName: 'Name',
          field: 'full_name',
          minWidth: 240,
          unSortIcon: true,
          sortable: true,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'Created By',
          field: 'created_by',
          minWidth: 220,
          unSortIcon: true,
          sortable: true
        },
        {
          headerName: 'User Name',
          field: 'user_name',
          minWidth: 220,
          unSortIcon: true,
          sortable: true,
          filter: true
        },
        {
          headerName: 'Company Name',
          field: 'company_name',
          minWidth: 230,
          unSortIcon: true,
          sortable: true
        },
        {
          headerName: 'Role',
          field: 'rank',
          minWidth: 160
        },
        {
          headerName: 'Start From',
          field: 'created_on',
          minWidth: 200,
          unSortIcon: true,
          sortable: true
        },
        {
          headerName: 'Action',
          width: 100,
          flex: 0,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer components
      components: {
        CellRendererActions,
        CellRendererStatus
      }
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    GetList() {
      this.$vs.loading()
      this.$store.dispatch('user/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 20,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        full_name: this.searchProduct
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },
    SearchWithField (e, field) {
      if (!e) delete this.filters[field]
      else {
        if (typeof e === 'object') this.filters[field] = e.value
        else this.filters[field] = e
      }

      this.GetList()
    },

    Close(){
      this.$store.dispatch('user/ChangePassword')
      this.new_password=""
    },
    SaveNewPass(){
      let payload = {
        password:this.new_password
      }
      // this.$vs.loading()
      this.new_password = ""
      this.$store.dispatch('user/ChangePassword')
      // this.$vs.loading.close()

     /* this.$store.dispatch('user/Edit', { id: this.id, data: payload })
        .then(res => {
          if (res.success) {
            this.$router.push({ name: 'admin-users-list' })
            this.ShowSuccessMessage({ title: 'Success', text: 'User has been edited' })
          }
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() =>
          this.$vs.loading.close(),
            this.new_password = "")*/
    },


    // Transform functions
    TransformList(item) {
      return {
        refreshData: this.GetList,
        user_id: item.user_id,
        status: item.status === 'active' ? true : false,
        full_name: item.full_name,
        created_by: item.created_by,
        user_name: item.user_name,
        company_name: item.company_name,
        rank: item.rank === 'Default' ? 'User' : 'Admin',
        created_on: item.created_on && format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
      }
    },
    onQuickFilterChanged() {
      this.GetList()
    },
  }
}
</script>
<style>
    .filter_input_user{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;
        margin-top: 20px;
    }


</style>
<style lang="scss" scoped >

  .modify-plan-container {
    padding: 65px 25px 25px;
    width: 400px;
    height: fit-content;
    background-color: white;
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    border-radius: 4px;

  .close-icon {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
  }
  }
  ::v-deep .svg-inline--fa{
    font-size: 2em;
  }.svg-inline--fa{
    font-size: 2em;
  }

</style>

